export const DIALOG_TYPE = {
  TERMS_AND_CONDITIONS: 'TermsAndConditions',
  ACCESSIBILITY: 'ACCESSIBILITY',
  MODERN_SLAVERY_ACT: 'ModernSlaveryAct',
  COOKIES: 'COOKIES'
};
